import { render } from "./ErrorView.vue?vue&type=template&id=60dd8b0b&scoped=true"
import script from "./ErrorView.vue?vue&type=script&lang=js"
export * from "./ErrorView.vue?vue&type=script&lang=js"

import "./ErrorView.vue?vue&type=style&index=0&id=60dd8b0b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60dd8b0b"

export default script